'use client';

import { useSearch } from '@/app/search-context';

export default function ActiveModelTagsClient({ className, }: { className: string }) {
  const { selectedModelTags, removeModelTag, dataLoading, } = useSearch();

  if (dataLoading || selectedModelTags.length === 0) {
    return <></>;
  }

  return (
    <div className={className}>
      {selectedModelTags.map((tag, index) => {
        const parts = tag.split(`:`);
        return (
          <button
            onClick={() => removeModelTag(tag)}
            key={index}
          >
            {`${parts[0]}${parts[1] ? ` - ${parts[1]}` : ``}`} &times;
          </button>
        );
      })}
    </div>
  );
}
